<template>
  <v-container class="fill-height align-content-start mt-16" fluid v-scroll="onScroll">
    <v-alert type="error" v-if="isOldBrowser" class="mb-12" style="width: 100%">
      <br />
      Du verkar använda en föråldrad version av webbläsare! <br />
      Vi rekommenderar Google Chrome för bästa upplevelse.
      <br /><br />
    </v-alert>

    <div v-if="showFloatingSavePanel" class="stickyButtonPanel">
      <v-btn color="green" dark rounded @click="save()" :disabled="images.length <= 0">
        <v-icon class="mr-2">mdi-check</v-icon>{{ $t('vendors.list.saveAllImages') }}
      </v-btn>

      <v-alert outlined :value="savedWithWarningsWithTimeout" type="warning" class="mb-0 mt-3">
        <div v-html="$t('vendors.list.savedButMissingInformationMessage')"></div>
      </v-alert>
      <v-alert outlined :value="savedSuccessfullyWithTimeout" type="success" class="mb-0 mt-3">{{
        $t('vendors.list.savedSuccessfullyMessage')
      }}</v-alert>
    </div>

    <v-row class="fill-height">
      <v-col class="fill-height">
        <v-tabs class="fill-height" @change="tabChanged">
          <v-tab>{{ $t('vendors.list.new') }}</v-tab>
          <v-tab>{{ $t('vendors.list.review') }}</v-tab>
          <v-tab>{{ $t('vendors.list.approved') }}</v-tab>
          <v-tab>{{ $t('vendors.list.rejected') }}</v-tab>

          <v-tab-item class="fill-height">
            <v-row class="fill-height">
              <v-col cols="12" sm="6" md="9" class="fill-height d-flex">
                <v-container fluid class="fill-height">
                  <div class="pa-4 flex grey lighten-4">
                    <div>
                      <v-btn color="green" dark rounded @click="save()" :disabled="images.length <= 0">
                        <v-icon class="mr-2">mdi-check</v-icon>{{ $t('vendors.list.saveAllImages') }}
                      </v-btn>
                      <v-btn
                        color="red"
                        dark
                        rounded
                        @click="deleteSelected()"
                        :disabled="images.length <= 0 || !hasSelectedImages()"
                      >
                        <v-icon class="mr-2">mdi-close-circle-outline</v-icon
                        >{{ $t('vendors.list.removeSelectedImages') }}
                      </v-btn>
                    </div>
                    <div class="caption grey--text save-hint mt-3">
                      <v-icon>mdi-alert-circle-outline</v-icon>
                      <div class="d-inline ml-2">
                        {{ $t('vendors.list.saveHintText') }}
                      </div>
                    </div>

                    <v-alert :value="savedWithWarnings" type="warning">
                      <div v-html="$t('vendors.list.savedButMissingInformationMessage')"></div>
                    </v-alert>
                    <v-alert :value="savedSuccessfully" type="success">{{
                      $t('vendors.list.savedSuccessfullyMessage')
                    }}</v-alert>
                    <v-alert :value="showDeleteError" type="error">{{ $t('vendors.list.removeErrorMessage') }}</v-alert>
                  </div>

                  <v-container
                    fluid
                    class="pt-0 pl-0 mt-5 image-container fill-height align-start"
                    @click="backgroundClick"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-btn class="grey lighten-2" rounded text @click.stop="selectAll">
                          <v-icon>mdi-select-all</v-icon>{{ $t('vendors.list.selectAllImages') }}
                        </v-btn>
                        <div class="caption grey--text save-hint mt-3">
                          <v-icon>mdi-alert-circle-outline</v-icon>
                          <div class="d-inline ml-2">
                            {{ $t('vendors.list.selectAllImagesHintText') }}
                          </div>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-flex"
                        sm="8"
                        md="6"
                        lg="3"
                        v-for="image in images"
                        :key="image.id"
                        @click.stop.prevent="toggleSelectImage($event, image)"
                        :class="{ 'blue lighten-3': image.selected }"
                      >
                        <v-card class="flex">
                          <v-img :src="getThumbnailPath(image)" contain height="200px">
                            <v-row slot="placeholder" class="fill-height align-center justify-center ma-0">
                              <v-progress-circular indeterminate color="grey"></v-progress-circular>
                            </v-row>
                          </v-img>

                          <v-card-actions class="card-action">
                            <span class="card-action-tag-item">
                              <v-icon>mdi-tag</v-icon>
                              {{ image.tags.length }}
                            </span>
                            <span class="card-action-category-item">
                              <v-icon>mdi-layers</v-icon>
                              {{
                                image.categories.length === 0
                                  ? $t('vendors.list.categoryMissing')
                                  : image.categories[0].description
                              }}
                            </span>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <!-- </v-row> -->
                </v-container>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="3" class="fill-height d-flex flex-column"> -->
              <v-col cols="12" sm="6" md="3" class="flex-column">
                <!-- höger kolumn -->
                <v-row>
                  <v-col cols="12" class="text-right pr-7">
                    <v-btn color="primary" dark rounded :to="{ name: 'Upload' }">
                      <v-icon class="mr-2">mdi-cloud-upload</v-icon>{{ $t('vendors.list.uploadImages') }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card class="ma-2">
                      <v-container fill-height>
                        <v-row>
                          <v-col cols="12">
                            <p class="text-body-2 mb-1" v-html="$t('vendors.list.imageInfoMessage1')"></p>
                            <p class="text-body-2 mb-1 font-italic" v-html="$t('vendors.list.imageInfoMessage2')"></p>
                            <p class="text-body-2" v-html="$t('vendors.list.imageInfoMessage1')"></p>
                            <v-divider class="mb-3"></v-divider>

                            <Box>
                              <TagAsObject
                                :label="$t('vendors.list.tags')"
                                :disabled="!hasSelectedImages()"
                                ref="mytag2"
                                @add="tagAdded($event)"
                                @remove="tagRemoved($event)"
                              ></TagAsObject>
                            </Box>
                            <Box>
                              <v-select
                                v-if="hasCompanyManyMainCategories()"
                                :label="$t('vendors.list.mainCategory')"
                                :disabled="!hasSelectedImages()"
                                :items="mainCategoriesForCompany"
                                item-text="description"
                                item-value="id"
                                v-model="selectedMainCategory"
                                return-object
                                class="mt-5"
                                @change="mainCategoryChanged"
                              ></v-select>

                              <v-select
                                :label="$t('vendors.list.category')"
                                :disabled="isCategoryDisabled"
                                :items="categories"
                                item-text="description"
                                item-value="id"
                                v-model="selectedCategory"
                                return-object
                                @change="categoryChanged($event)"
                                class="mt-5"
                              ></v-select>
                            </Box>
                            <Box>
                              <p class="d-block theme--light" :class="{ 'v-label--is-disabled': !hasSelectedImages() }">
                                {{ $t('vendors.list.description') }}
                              </p>
                              <v-tabs v-model="descriptionTab">
                                <v-tab :disabled="!hasSelectedImages()">{{ $t('vendors.list.swedish') }}</v-tab>
                                <v-tab :disabled="!hasSelectedImages()">{{ $t('vendors.list.english') }}</v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="descriptionTab">
                                <v-tab-item>
                                  <v-textarea
                                    :label="$t('vendors.list.descriptionInSwedish')"
                                    v-model="selectedSwedishDescription"
                                    :disabled="!hasSelectedImages()"
                                    @input="swedishDescriptionChanged($event)"
                                    hide-details
                                  ></v-textarea>
                                </v-tab-item>
                                <v-tab-item>
                                  <v-textarea
                                    :label="$t('vendors.list.descriptionInEnglish')"
                                    v-model="selectedEnglishDescription"
                                    :disabled="!hasSelectedImages()"
                                    @input="englishDescriptionChanged($event)"
                                    hide-details
                                  ></v-textarea>
                                </v-tab-item>
                              </v-tabs-items>
                            </Box>
                            <Box>
                              <v-radio-group
                                v-model="selectedType"
                                @change="typeChanged($event)"
                                :label="$t('vendors.list.typeOfImage')"
                                :disabled="!hasSelectedImages()"
                              >
                                <v-radio :label="$t('vendors.list.environmentImage')" :value="1"></v-radio>
                                <v-radio :label="$t('vendors.list.productImage')" :value="2"></v-radio>
                              </v-radio-group>
                            </Box>
                            <Box>
                              <v-combobox
                                multiple
                                small-chips
                                :label="$t('vendors.list.color')"
                                item-text="text"
                                v-model="selectedColors"
                                :items="lookupStore.colorsWithoutAllOption"
                                :disabled="!hasSelectedImages()"
                                @change="colorChanged($event)"
                                return-object
                              ></v-combobox>
                              <div class="caption grey--text mb-5">
                                <div class="d-inline" v-html="$t('vendors.list.missingColorText')"></div>
                              </div>
                            </Box>
                            <Box>
                              <v-text-field
                                :label="$t('vendors.list.price')"
                                @input="priceChanged($event)"
                                v-model="selectedPrice"
                                :disabled="!hasSelectedImages()"
                              ></v-text-field>
                              <v-text-field
                                :label="$t('vendors.list.englishPrice')"
                                @input="englishPriceChanged($event)"
                                v-model="selectedEnglishPrice"
                                :disabled="!hasSelectedImages()"
                              ></v-text-field>
                            </Box>
                            <Box>
                              <v-select
                                :label="$t('vendors.list.season')"
                                :disabled="!hasSelectedImages()"
                                :items="lookupStore.seasons"
                                item-text="text"
                                item-value="id"
                                v-model="selectedSeason"
                                return-object
                                @change="seasonChanged($event)"
                              ></v-select>
                            </Box>
                            <Box>
                              <v-checkbox
                                :label="$t('vendors.list.newProduct')"
                                :disabled="!hasSelectedImages()"
                                @change="isNewProductChanged($event)"
                                v-model="selectedIsNewProduct"
                                :hide-details="true"
                              ></v-checkbox>

                              <v-menu
                                v-model="releaseDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="selectedReleaseDate"
                                    :disabled="!selectedIsNewProduct"
                                    :label="$t('vendors.list.selectLaunchDate')"
                                    readonly
                                    v-on="on"
                                    class="mb-3"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  @change="releaseDateChanged($event)"
                                  v-model="selectedReleaseDate"
                                  @input="releaseDateMenu = false"
                                ></v-date-picker>
                              </v-menu>
                            </Box>
                            <Box>
                              <v-text-field
                                :label="$t('vendors.list.externalUrl')"
                                @input="externalUrlChanged($event)"
                                v-model="selectedExternalUrl"
                                :disabled="!hasSelectedImages()"
                              ></v-text-field>
                            </Box>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item class="fill-height" :eager="true">
            <review ref="review"></review>
          </v-tab-item>
          <v-tab-item class="fill-height" :eager="true">
            <approved ref="approved"></approved>
          </v-tab-item>
          <v-tab-item class="fill-height" :eager="true">
            <rejected ref="rejected"></rejected>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

    <v-dialog v-model="showUnsavedWarning" max-width="500" :persistent="true">
      <v-card>
        <v-card-title class="headline">{{ $t('vendors.list.unsavedChangesTitle') }}</v-card-title>

        <v-card-text>
          <h3 v-html="$t('vendors.list.unsavedChangesMessage')"></h3>
        </v-card-text>

        <v-card-actions class="pr-4 pb-3">
          <v-spacer></v-spacer>

          <v-btn outlined text @click="cancelNavigation()"> {{ $t('common.cancel') }} </v-btn>

          <v-btn color="primary" class="black--text" @click="continueNavigation()"> {{ $t('common.continue') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { FileService } from '../../services/file.service';
import TagAsObject from '../../components/common/TagAsObjectComponent.vue';
import Review from './list-tabs/ReviewComponent.vue';
import Approved from './list-tabs/ApprovedComponent.vue';
import Rejected from './list-tabs/RejectedComponent.vue';
import Box from '@shared/components/BoxComponent.vue';
import { mapStores } from 'pinia';
import { useLookupStore } from '../../stores/LookupStore';
import { useUserStore } from '../../stores/UserStore';

export default {
  components: {
    TagAsObject,
    Box,
    Review,
    Approved,
    Rejected,
  },

  data() {
    return {
      images: [],
      categories: [],
      selectedImages: [],
      selectedMainCategory: undefined,
      selectedCategory: undefined,
      selectedColors: undefined,
      selectedSeason: undefined,
      selectedSwedishDescription: undefined,
      selectedEnglishDescription: undefined,
      selectedPrice: undefined,
      selectedEnglishPrice: undefined,
      selectedExternalUrl: undefined,
      selectedIsNewProduct: undefined,
      selectedReleaseDate: undefined,
      selectedType: undefined,
      releaseDateMenu: false,
      activeTab: undefined,
      lastSelectedImage: undefined,
      savedWithWarnings: false,
      savedSuccessfully: false,
      savedWithWarningsWithTimeout: false,
      savedSuccessfullyWithTimeout: false,
      savedWithWarningsWithTimeoutId: undefined,
      savedSuccessfullyWithTimeoutId: undefined,
      showDeleteError: false,
      changesHasBeenMade: false,
      showUnsavedWarning: false,
      unsavedWarningPromise: undefined,
      unsavedWarningPromiseResolve: undefined,
      unsavedWarningPromiseReject: undefined,
      showFloatingSavePanel: false,
      descriptionTab: 0,
    };
  },

  async beforeRouteLeave(to, from, next) {
    if (!this.changesHasBeenMade) {
      return next();
    }
    this.showUnsavedWarning = true;
    this.unsavedWarningPromise = new Promise((resolve, reject) => {
      this.unsavedWarningPromiseResolve = resolve;
      this.unsavedWarningPromiseReject = reject;
    });

    const response = await this.unsavedWarningPromise.then(() => true).catch(() => false);
    if (response) {
      next();
    } else {
      next(false);
    }
  },

  computed: {
    ...mapStores(useLookupStore, useUserStore),

    isOldBrowser() {
      return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    },

    isCategoryDisabled() {
      if (this.hasCompanyManyMainCategories()) {
        return !(this.hasSelectedImages() && !!this.selectedMainCategory?.id);
      }
      return !this.hasSelectedImages();
    },

    mainCategoriesForCompany() {
      return this.userStore.selectedCompanyMainCategories;
    },
  },

  async mounted() {
    if (!this.hasCompanyManyMainCategories()) {
      // this.selectedMainCategory = Object.assign({}, this.userStore.selectedCompany.main_categories[0]);
      this.selectedMainCategory = { id: this.userStore.selectedCompany.main_categories[0] };
      this.updateSubCategoryList(this.selectedMainCategory);
    }

    this.userStore.$subscribe(() => this.$router.push({ name: 'Dashboard' }));

    await this.lookupStore.loadSeasons();

    this.loadImages();
  },

  methods: {
    hasCompanyManyMainCategories() {
      return this.userStore.hasSelectedCompanyManyCategories;
    },

    cancelNavigation() {
      this.showUnsavedWarning = false;
      this.unsavedWarningPromiseReject(false);
    },

    continueNavigation() {
      this.showUnsavedWarning = false;
      this.unsavedWarningPromiseResolve(true);
    },

    async tabChanged(tabKey) {
      this.activeTab = tabKey;

      if (tabKey === 1) {
        this.$refs.review.reload();
      } else if (tabKey === 2) {
        this.$refs.approved.reload();
      } else if (tabKey === 3) {
        this.$refs.rejected.reload();
      }
    },

    getThumbnailPath(image) {
      return `${image.path}/thumb/thumb_sm_${image.thumb_name.substring(6)}`;
    },

    selectAll() {
      this.images.forEach((image) => {
        image.selected = true;
      });
      this.refreshInformationPanel();
    },

    unselectAll() {
      this.images.forEach((image) => {
        image.selected = false;
      });
      this.refreshInformationPanel();
    },

    backgroundClick(event) {
      this.unselectAll();
      this.selectedCategory = undefined;
      this.selectedSeason = undefined;
      this.selectedColors = undefined;
      this.selectedSwedishDescription = undefined;
      this.selectedEnglishDescription = undefined;
      this.selectedPrice = undefined;
      this.selectedEnglishPrice = undefined;
      this.selectedExternalUrl = undefined;
      this.selectedIsNewProduct = undefined;
      this.selectedReleaseDate = undefined;
      this.selectedType = undefined;
      // this.$refs.mytag.setTags([]);
      this.$refs.mytag2.setTags([]);
    },

    toggleSelectImage(event, image) {
      if (!event.ctrlKey) {
        this.unselectAll();
      }

      if (event.shiftKey) {
        const currentImageIndex = this.images.indexOf(image);
        const lastImageIndex = this.images.indexOf(this.lastSelectedImage);
        const indexArr = [currentImageIndex, lastImageIndex].sort();

        for (let i = indexArr[0]; i <= indexArr[1]; i++) {
          this.images[i].selected = true;
        }
      } else {
        image.selected = !image.selected;
        this.lastSelectedImage = image;
      }

      this.refreshInformationPanel();
    },

    refreshInformationPanel() {
      // categories
      const filteredCategories = this.filterCategoriesWithArray();
      const categoryKeys = Object.keys(filteredCategories);

      this.selectedCategory = categoryKeys.length === 1 ? filteredCategories[categoryKeys[0]] : undefined;

      if (this.hasCompanyManyMainCategories()) {
        if (!!this.selectedCategory?.main_category_id) {
          // om valda bilderna har category så sätter vi main category utifrån den
          this.selectedMainCategory = { id: this.selectedCategory.main_category_id };
        } else if (categoryKeys.length > 0) {
          // check if same main category on selected images categories
          const mainCategoryIds = Object.values(filteredCategories).map((c) => c.main_category_id);
          const mainCategorySet = new Set(mainCategoryIds); // unik lista av id'n
          this.selectedMainCategory =
            mainCategorySet.size === 1 ? { id: mainCategorySet.values().next().value } : undefined;
        } else {
          this.selectedMainCategory = undefined;
        }

        this.updateSubCategoryList(this.selectedMainCategory);
      }

      // tags
      this.$refs.mytag2.setTags(this.filterTags2());

      // colors
      this.selectedColors = this.filterColors();

      // seasons
      const filteredSeasons = this.filterSeason();
      const seasonKeys = Object.keys(filteredSeasons);
      this.selectedSeason = seasonKeys.length === 1 ? filteredSeasons[seasonKeys[0]] : undefined;

      // other
      this.selectedSwedishDescription = this.filterSwedishDescription();
      this.selectedEnglishDescription = this.filterEnglishDescription();
      this.selectedPrice = this.filterPrice();
      this.selectedEnglishPrice = this.filterEnglishPrice();
      this.selectedExternalUrl = this.filterExternalUrl();
      this.selectedIsNewProduct = this.filterIsNewProduct();
      this.selectedReleaseDate = this.filterReleaseDate();
      this.selectedType = this.filterType();
    },

    filterSwedishDescription() {
      let descriptionFilter = { text: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!descriptionFilter.isSet) {
          descriptionFilter.text = image.description;
          descriptionFilter.isSet = true;
        } else if (descriptionFilter.isSet && descriptionFilter.text !== image.description) {
          descriptionFilter.text = undefined;
        }
      });

      return descriptionFilter.text;
    },

    filterEnglishDescription() {
      let descriptionFilter = { text: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!descriptionFilter.isSet) {
          descriptionFilter.text = image.description_eng;
          descriptionFilter.isSet = true;
        } else if (descriptionFilter.isSet && descriptionFilter.text !== image.description_eng) {
          descriptionFilter.text = undefined;
        }
      });

      return descriptionFilter.text;
    },

    filterPrice() {
      let priceFilter = { text: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!priceFilter.isSet) {
          priceFilter.text = image.price;
          priceFilter.isSet = true;
        } else if (priceFilter.isSet && priceFilter.text !== image.price) {
          priceFilter.text = undefined;
        }
      });

      return priceFilter.text;
    },

    filterEnglishPrice() {
      let priceFilter = { text: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!priceFilter.isSet) {
          priceFilter.text = image.price_eng;
          priceFilter.isSet = true;
        } else if (priceFilter.isSet && priceFilter.text !== image.price_eng) {
          priceFilter.text = undefined;
        }
      });

      return priceFilter.text;
    },

    filterExternalUrl() {
      let extUrlFilter = { text: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!extUrlFilter.isSet) {
          extUrlFilter.text = image.external_url;
          extUrlFilter.isSet = true;
        } else if (extUrlFilter.isSet && extUrlFilter.text !== image.external_url) {
          extUrlFilter.text = undefined;
        }
      });

      return extUrlFilter.text;
    },

    filterIsNewProduct() {
      let isNewProdFilter = { checked: false, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!isNewProdFilter.isSet) {
          isNewProdFilter.checked = image.is_new_product;
          isNewProdFilter.isSet = true;
        } else if (isNewProdFilter.isSet && isNewProdFilter.checked !== image.is_new_product) {
          isNewProdFilter.checked = false;
        }
      });

      return isNewProdFilter.checked;
    },

    filterReleaseDate() {
      let releaseDateFilter = { text: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!releaseDateFilter.isSet) {
          releaseDateFilter.text = image.release_date;
          releaseDateFilter.isSet = true;
        } else if (releaseDateFilter.isSet && releaseDateFilter.text !== image.release_date) {
          releaseDateFilter.text = undefined;
        }
      });

      return releaseDateFilter.text;
    },

    filterType() {
      let typeFilter = { value: undefined, isSet: false };

      this.getSelectedImages().forEach((image) => {
        if (!typeFilter.isSet) {
          typeFilter.value = image.type;
          typeFilter.isSet = true;
        } else if (typeFilter.isSet && typeFilter.value !== image.type) {
          typeFilter.value = undefined;
        }
      });

      return typeFilter.value;
    },

    filterSeason() {
      let seasonFilter = {};

      this.getSelectedImages().forEach((image) => {
        if (!image.season) {
          seasonFilter['none'] = {};
          return;
        }

        seasonFilter[image.season.id] = image.season;
      });

      return seasonFilter;
    },

    filterColors() {
      let colorFilter = {};
      const selectedImages = this.getSelectedImages();

      selectedImages.forEach((image) => {
        image.colors.forEach((c) => {
          colorFilter[c.id] ? colorFilter[c.id]++ : (colorFilter[c.id] = 1);
        });
      });

      const filteredColors = Object.keys(colorFilter).filter((key) => colorFilter[key] >= selectedImages.length);

      return this.lookupStore.colors.filter((c) => filteredColors.includes(c.id.toString()));
    },

    filterCategoriesWithArray() {
      const categoriesFilter = {};
      const selectedImages = this.getSelectedImages();

      selectedImages.forEach((image) => {
        if (image.categories.length === 0) {
          categoriesFilter['none'] = {};
          return;
        }

        image.categories.forEach((cat) => {
          categoriesFilter[cat.id] = cat;
        });
      });

      return categoriesFilter;
    },

    filterTags2() {
      const tagsFilter = {};
      const selectedImages = this.getSelectedImages();

      selectedImages.forEach((i) => {
        i.tags.forEach((t) => {
          const tagId = t.id;
          tagsFilter[tagId] ? tagsFilter[tagId].count++ : (tagsFilter[tagId] = { count: 1, tag: t });
        });
      });

      return Object.keys(tagsFilter)
        .filter((key) => tagsFilter[key].count >= selectedImages.length)
        .map((key) => tagsFilter[key].tag);
    },

    getSelectedImages() {
      return this.images.filter((i) => i.selected);
    },

    hasSelectedImages() {
      return this.images.some((x) => x.selected);
    },

    mainCategoryChanged($event) {
      this.updateSubCategoryList($event);
      this.getSelectedImages().forEach((image) => (image.categories = []));
    },

    updateSubCategoryList(mainCategory) {
      if (!mainCategory) {
        this.categories = [];
        return;
      }

      this.categories = this.lookupStore.categoriesByMainCategory(mainCategory);
    },

    categoryChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.categories = [$event]));
    },

    colorChanged($event) {
      // $event is an array of color objects if the user has clicked on a color
      // but can be a string if the user has typed in a color
      const findColorObjectByText = (color) =>
        this.lookupStore.colors.find((c) => c.text.toLowerCase().startsWith(color.toLowerCase()));

      const makeUnique = (value, index, self) => self.findIndex((c) => c.id === value.id) === index;

      const colors = $event
        .map((c) => {
          if (c.id) {
            return c;
          }
          return findColorObjectByText(c);
        })
        .filter((c) => !!c)
        .filter(makeUnique);

      this.selectedColors = colors;
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.colors = colors));
    },

    seasonChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.season = $event));
    },

    swedishDescriptionChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.description = $event));
    },

    englishDescriptionChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.description_eng = $event));
    },

    isNewProductChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => {
        image.is_new_product = $event;
        if ($event === false) {
          image.release_date = undefined;
        }
      });
    },

    releaseDateChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.release_date = $event));
    },

    typeChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.type = $event));
    },

    priceChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.price = $event));
    },

    englishPriceChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.price_eng = $event));
    },

    externalUrlChanged($event) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => (image.external_url = $event));
    },

    tagAdded(tag) {
      this.changesHasBeenMade = true;
      const hasTag = (existingTag) => existingTag.id === tag.id;

      this.getSelectedImages().forEach((image) => {
        if (!image.tags.some(hasTag)) {
          image.tags.push(tag);
        }
      });
    },

    tagRemoved(tag) {
      this.changesHasBeenMade = true;
      this.getSelectedImages().forEach((image) => {
        image.tags.splice(
          image.tags.findIndex((imageTag) => imageTag.id === tag.id),
          1
        );
        // image.tags.splice(image.tags.indexOf(tag), 1);
      });
    },

    clearErrorsAndWarnings() {
      this.savedWithWarnings = false;
      this.savedSuccessfully = false;
      this.showDeleteError = false;
      this.savedWithWarningsWithTimeout = false;
      this.savedSuccessfullyWithTimeout = false;

      this.savedSuccessfullyWithTimeoutId && clearTimeout(this.savedSuccessfullyWithTimeoutId);
      this.savedWithWarningsWithTimeoutId && clearTimeout(this.savedWithWarningsWithTimeoutId);
    },

    save() {
      this.clearErrorsAndWarnings();

      new FileService()
        .save(this.images)
        .then(() => {
          this.savedWithWarnings = !this.hasAllImagesMandatoryFields();
          this.savedSuccessfully = this.hasAllImagesMandatoryFields();

          this.savedWithWarningsWithTimeout = this.savedWithWarnings;
          this.savedSuccessfullyWithTimeout = this.savedSuccessfully;

          if (this.savedSuccessfullyWithTimeout) {
            this.savedSuccessfullyWithTimeoutId && clearTimeout(this.savedSuccessfullyWithTimeoutId);
            this.savedSuccessfullyWithTimeoutId = setTimeout(() => {
              this.savedSuccessfullyWithTimeout = false;
            }, 5000);
          }
          if (this.savedWithWarningsWithTimeout) {
            this.savedWithWarningsWithTimeoutId && clearTimeout(this.savedWithWarningsWithTimeoutId);
            this.savedWithWarningsWithTimeoutId = setTimeout(() => {
              this.savedWithWarningsWithTimeout = false;
            }, 5000);
          }

          this.unselectAll();
        })
        .then(this.loadImages);
    },

    /**
     * Checks if some images missing mandatory fields like tags, category and color
     * The images has to have a category and at least one tag and one color to be "moved" to review.
     */
    hasAllImagesMandatoryFields() {
      return this.images.every((x) => {
        return x.categories.length > 0 && x.tags.length > 0 && x.colors.length > 0;
      });
    },

    loadImages() {
      this.changesHasBeenMade = false;

      new FileService()
        .getAll()
        .then((data) => {
          this.images = data.data;
          this.images.forEach((image) => {
            this.$set(image, 'selected', false);
          });
        })
        .then(() => {
          this.lastSelectedImage = this.images.length > 0 ? this.images[0] : undefined;
        });
    },

    deleteSelected() {
      const selectedImages = this.getSelectedImages();

      this.clearErrorsAndWarnings();

      new FileService()
        .delete(selectedImages)
        .then(() => {
          const selectedImageIds = selectedImages.map((val) => val.id);

          this.images = this.images.reduce((prev, curr) => {
            return selectedImageIds.indexOf(curr.id) >= 0 ? prev : [...prev, curr];
          }, []);

          this.unselectAll();
        })
        .catch((error) => {
          console.error('Delete images failed.', error);
          this.showDeleteError = true;
        });
    },

    onScroll(event) {
      this.showFloatingSavePanel = event.target.scrollingElement.scrollTop > 240 && this.activeTab === 0;
    },
  },
};
</script>

<style lang="scss">

.card.selected {
  border-top: 3px solid green;
}
.card-action {
  padding: 16px 8px;
}
.card-action-tag-item {
  margin-right: 20px;
}

.btn i.icon {
  padding-right: 5px;
}

.image-container {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: hsla(0, 0%, 0%, 0.32) !important;
}

div.save-hint {
  display: flex;
  align-items: center;
}

.theme--light.v-tabs-items {
  height: calc(100% - 48px); // 48 är höjden på tabb-raden
}

.v-window__container {
  height: 100%;
}

.stickyButtonPanel {
  position: sticky;
  z-index: 1000;
  top: 45px;
  background-color: white;
  padding: 20px;
  border: 1px solid #666;
  left: 23px;
  box-shadow: 2px ​2px 10px #bbb;
}
</style>
